/* import __COLOCATED_TEMPLATE__ from './empty-tags-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();